export default "__VITE_ASSET__Bxcr822J__"